export const IMAGES = {
  heroDesktop: "/hero-desktop.webp",
  heroMobile: "/hero-mobile.webp",
  heroUrbanNight:
    "https://images.unsplash.com/photo-1628634450839-021b6c297906?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHx1cmJhbiUyMG1vYmlsaXR5JTIwdGF4aSUyMGFwcCUyMHBhc3NlbmdlciUyMGRyaXZlciUyMGNpdHklMjBuaWdodCUyMGVsZWN0cmljJTIwY2FyJTIwYnJhemlsfGVufDB8fHx8MTc5MjExOTU4Nnww&ixlib=rb-4.1.0&q=85",
  passengerRide:
    "https://images.pexels.com/photos/5835466/pexels-photo-5835466.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  driverNav:
    "https://images.unsplash.com/photo-1565128446913-4433ca388a53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjaXR5JTIwZHJpdmVyJTIwY2FyJTIwY29tbXV0ZSUyMG5pZ2h0JTIwdXJiYW58ZW58MHx8fHwxNzkyMTE5NTk1fDA&ixlib=rb-4.1.0&q=85",
  skyline:
    "https://images.unsplash.com/photo-1634615116008-7b55fdc33c24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHx1cmJhbiUyMG1vYmlsaXR5JTIwdGF4aSUyMGFwcCUyMHBhc3NlbmdlciUyMGRyaXZlciUyMGNpdHklMjBuaWdodCUyMGVsZWN0cmljJTIwY2FyJTIwYnJhemlsfGVufDB8fHx8MTc5MjExOTU4Nnww&ixlib=rb-4.1.0&q=85",
  safetyTech:
    "https://images.pexels.com/photos/7263902/pexels-photo-7263902.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_LINKS = [
  { label: "Início", to: "/" },
  { label: "360Taxi", to: "/360taxi" },
  { label: "Passageiros", to: "/passageiros" },
  { label: "Motoristas", to: "/motoristas" },
  { label: "Futuro OFF360", to: "/futuro-off360" },
  { label: "Segurança", to: "/seguranca" },
  { label: "Sobre", to: "/sobre" },
  { label: "Suporte", to: "/suporte" },
];

export const INTERESTS = [
  "Passageiro 360Taxi",
  "Motorista 360Taxi",
  "Comércio e Descontos",
  "Empresários",
  "Entregas",
  "360Moto",
  "Outros serviços e oportunidades",
];

export const SUPPORT_CATEGORIES = [
  "Cadastro e acesso",
  "Motoristas",
  "Passageiros",
  "Corridas",
  "Pagamentos",
  "Segurança",
  "Privacidade",
  "Exclusão de conta",
  "Próximos lançamentos",
  "Outros assuntos",
];

export const SOON_PAGES = {
  empresarios: {
    slug: "/empresarios",
    eyebrow: "OFF360 para Empresários",
    title: "Seu negócio terá novas oportunidades com o OFF360.",
    text: "Estamos preparando um ambiente digital que permitirá aos empresários ampliar a presença de seus estabelecimentos, divulgar campanhas e criar oportunidades de relacionamento com consumidores.",
    extra:
      "Entre os recursos planejados estão campanhas promocionais, descontos, anúncios e ferramentas inteligentes de divulgação.",
    aviso:
      "O OFF360 para Empresários está em desenvolvimento e ainda não está disponível para contratação. O 360Taxi é o serviço principal do lançamento atual.",
    interest: "Empresários",
    image: IMAGES.skyline,
    imageAlt: "Centro urbano à noite, símbolo de novos negócios",
  },
  "360moto": {
    slug: "/360moto",
    eyebrow: "360Moto",
    title: "360Moto — Uma nova forma de se movimentar está chegando.",
    text: "O OFF360 está preparando uma nova opção de mobilidade urbana sobre duas rodas, voltada à praticidade dos deslocamentos.",
    extra: "",
    aviso:
      "Modalidade em desenvolvimento. Ainda não disponível para solicitação de corridas ou cadastro operacional.",
    interest: "360Moto",
    image: IMAGES.driverNav,
    imageAlt: "Mobilidade urbana em movimento",
  },
  entregas: {
    slug: "/entregas",
    eyebrow: "OFF360 Entregas",
    title: "OFF360 Entregas — Mais praticidade para sua rotina.",
    text: "Estamos preparando soluções para conectar pessoas, estabelecimentos e serviços de entrega em uma experiência mais integrada.",
    extra: "",
    aviso: "Serviço em desenvolvimento, sem operação disponível neste momento.",
    interest: "Entregas",
    image: IMAGES.passengerRide,
    imageAlt: "Rotina urbana conectada pela tecnologia",
  },
};

export const FOOTER_COLS = [
  {
    title: "OFF360",
    links: [
      { label: "Início", to: "/" },
      { label: "Sobre nós", to: "/sobre" },
      { label: "360Taxi", to: "/360taxi" },
      { label: "Futuro OFF360", to: "/futuro-off360" },
    ],
  },
  {
    title: "Serviços",
    links: [
      { label: "Passageiros", to: "/passageiros" },
      { label: "Motoristas", to: "/motoristas" },
      { label: "Empresários — Em breve", to: "/empresarios" },
      { label: "360Moto — Em breve", to: "/360moto" },
      { label: "Entregas — Em breve", to: "/entregas" },
    ],
  },
  {
    title: "Ajuda",
    links: [
      { label: "Central de Suporte", to: "/suporte" },
      { label: "Segurança", to: "/seguranca" },
      { label: "Perguntas frequentes", to: "/suporte#perguntas-frequentes" },
      { label: "Contato", to: "/suporte" },
    ],
  },
  {
    title: "Informações legais",
    links: [
      { label: "Política de Privacidade", to: "/politica-de-privacidade" },
      { label: "Termos de Passageiros", to: "/termos-passageiros" },
      { label: "Termos de Motoristas", to: "/termos-motoristas" },
      { label: "Termos de Empresários", to: "/termos-empresarios" },
      { label: "Exclusão de Conta", to: "/excluir-conta" },
    ],
  },
];

export const FAQ_PASSAGEIROS = [
  {
    q: "Como solicitar uma corrida?",
    a: "No aplicativo 360Taxi, informe o local de partida e o destino, escolha a categoria disponível na sua região e confirme a solicitação. O aplicativo apresentará as informações da viagem e do motorista.",
  },
  {
    q: "Como selecionar a categoria?",
    a: "As categorias disponíveis (Básico, Select e Premium, quando ativas na região) são apresentadas no aplicativo antes de confirmar a corrida. A disponibilidade depende da região e da operação.",
  },
  {
    q: "Quais formas de pagamento são aceitas?",
    a: "O aplicativo poderá disponibilizar Pix, cartão e dinheiro. As opções efetivamente disponíveis respeitam a configuração da operação e os métodos aceitos para a corrida.",
  },
  {
    q: "Como acompanhar o motorista?",
    a: "Após a confirmação, o aplicativo exibe as informações do motorista, do veículo e o acompanhamento da corrida até o destino.",
  },
  {
    q: "Como compartilhar uma viagem?",
    a: "Durante a corrida, utilize o recurso de compartilhamento de viagem do aplicativo para enviar o acompanhamento a pessoas de sua confiança.",
  },
  {
    q: "Como solicitar suporte?",
    a: "Acesse a Central de Suporte pelo site ou pelos canais oficiais do aplicativo. Também disponibilizamos o WhatsApp oficial e o e-mail contato@off360.com.br.",
  },
  {
    q: "Como excluir minha conta?",
    a: "Acesse a página Exclusão de Conta e Dados, preencha o formulário e guarde o número de protocolo. A titularidade será verificada antes do tratamento da solicitação.",
  },
];

export const FAQ_MOTORISTAS = [
  {
    q: "Como faço meu cadastro?",
    a: "O cadastro é realizado pelo aplicativo: informações pessoais, documentação (CNH com EAR), dados do veículo e, após essas etapas, o cadastro financeiro exigido para recebimentos.",
  },
  {
    q: "Quais documentos são exigidos?",
    a: "São exigidos CNH válida com EAR e os documentos do veículo, além de demais comprovações previstas na legislação e nas regras da plataforma.",
  },
  {
    q: "Como funciona a aprovação?",
    a: "A plataforma realiza a análise das informações e determina a situação cadastral. O envio da documentação não garante aprovação automática.",
  },
  {
    q: "Quem determina minha categoria?",
    a: "A classificação (Básico, Select ou Premium) é determinada pela plataforma durante o processo de cadastro e validação, conforme análise e requisitos internos.",
  },
  {
    q: "Quando posso ficar online?",
    a: "Somente motoristas aprovados e com os requisitos de acesso regularizados poderão ficar online e receber solicitações.",
  },
  {
    q: "Como funcionam as mensalidades?",
    a: "O modelo comercial é baseado em mensalidade, sem comissão percentual da plataforma sobre cada corrida. O valor da mensalidade varia por faixa de faturamento mensal — consulte a tabela oficial publicada nesta página.",
  },
  {
    q: "Como recebo os pagamentos?",
    a: "Você poderá acompanhar recebimentos e movimentações pelos recursos financeiros da plataforma. Pagamentos eletrônicos e transferências dependem da integração financeira habilitada; corridas em dinheiro poderão ser permitidas conforme as configurações.",
  },
  {
    q: "Como acompanho minhas corridas?",
    a: "O aplicativo apresenta o histórico e as informações das corridas realizadas, conforme os recursos disponíveis na plataforma.",
  },
  {
    q: "Como atualizo os dados do veículo?",
    a: "As atualizações de dados e documentos do veículo são feitas pelo próprio aplicativo, sujeitas à validação da plataforma.",
  },
  {
    q: "Como solicito suporte?",
    a: "Utilize os canais oficiais do aplicativo, a Central de Suporte do site, o WhatsApp oficial ou o e-mail contato@off360.com.br.",
  },
];
